<app-header *ngIf="!router.url.includes('login')"></app-header>

<div [ngClass]="{ 'main-container full-height': !router.url.includes('login') }">
  <router-outlet></router-outlet>
</div>


<app-footer *ngIf="!router.url.includes('login')"></app-footer>